import { Events } from 'src/constants/webSocketConsts/events';
import {
  loadPortalSettingsAction,
  removePortalSettingsAction,
  updateBillingSettingsSucceededAction,
} from 'src/store/settings/actions';
import {
  BillingSettings,
  ExtensionsSettings,
  ModuleSettingsItem,
  PortalSettings,
} from 'src/constants/dataTypes';
import { ensureUnreachable } from 'src/utils/common_utils';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { applicationSettingsApi } from 'src/services/api/applicationsApi';
import { automationsApi } from 'src/services/api/automationsApi';
import { ApiTags } from 'src/services/api';

const portalSettingsHandler = (event: Events, items: Array<PortalSettings>) => {
  if (items.length === 0) {
    return null;
  }
  switch (event) {
    case Events.Remove:
      removePortalSettingsAction(items);
      return handlePortalSettingsChanges(
        items.at(0)?.fields.moduleSettings || [],
        items.at(0)?.fields.extensionsSettings || {},
        items.at(0)?.fields.billingSettings || {},
      );
    case Events.Insert:
    case Events.Modify:
      loadPortalSettingsAction(items);
      return handlePortalSettingsChanges(
        items.at(0)?.fields.moduleSettings || [],
        items.at(0)?.fields.extensionsSettings || {},
        items.at(0)?.fields.billingSettings || {},
      );
    case Events.DomainVerified:
    case Events.Refresh:
      return null;
    default:
      return ensureUnreachable(event);
  }
};

export default portalSettingsHandler;

export const handlePortalSettingsChanges =
  (
    moduleSettings: ModuleSettingsItem[],
    extensionsSettings: ExtensionsSettings,
    billingSettings: BillingSettings,
  ) =>
  async (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(
      applicationSettingsApi.util.updateQueryData(
        'getInstalls',
        undefined,
        (draftState) => {
          draftState.moduleSettings = moduleSettings;
          draftState.extensionsSettings = extensionsSettings;
          return;
        },
      ),
    );
    dispatch(updateBillingSettingsSucceededAction(billingSettings));
    // invalidate GET templates/actions/triggers to fetch the updated data
    dispatch(automationsApi.util.invalidateTags([ApiTags.automationTemplates]));
    dispatch(automationsApi.util.invalidateTags([ApiTags.automationActions]));
    dispatch(automationsApi.util.invalidateTags([ApiTags.automationTriggers]));
  };
